import { render, staticRenderFns } from "./OrientationView.vue?vue&type=template&id=09cfebf4&"
var script = {}
import style0 from "./OrientationView.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports